
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import PendingIcon from '@mui/icons-material/Pending';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import { MetricCard, MetricCardConfig } from '../CardProdMetrics/MetricalSumari';



interface Props {
  total: number;
  pendientes: number;
  aprobados: number;
  rechazado: number;
  implementado: number;
}

export const ResumenCambioCards = ({ total, pendientes, aprobados, rechazado, implementado }: Props) => {
  const cardsConfig: MetricCardConfig[] = [
    {
      label: 'Total CC',
      value: total,
      icon: <AllInclusiveIcon sx={{ fontSize: 28 }} />,
      color: '#1976d2',
      bgLight: '#e3f2fd',
    },
    {
      label: 'Pendientes',
      value: pendientes,
      icon: <PendingIcon sx={{ fontSize: 28 }} />,
      color: '#ed6c02',
      bgLight: '#fff3e0',
    },
    {
      label: 'Aprobados',
      value: aprobados,
      icon: <CheckCircleIcon sx={{ fontSize: 28 }} />,
      color: '#2e7d32',
      bgLight: '#e8f5e9',
    },
    {
      label: 'Rechazado',
      value: rechazado,
      icon: <DoDisturbAltIcon sx={{ fontSize: 28 }} />,
      color: '#9b0505',
      bgLight: '#e0f2fe',
    },
    {
      label: 'Implementado',
      value: implementado,
      icon: <DoDisturbAltIcon sx={{ fontSize: 28 }} />,
      color: '#088d8d',
      bgLight: '#e0f2fe',
    },
  ];

  return <MetricCard cards={cardsConfig} />;
};